define('dialog',['underscore', 'easyXDM/easyXDM', 'utils/guid','utils/dom_helper', 'dialog/css', 'dialog/resize', 'observable', 'utils/user_agent'], function(_, XDM, guid, DomHelper, CSS, Resize, Observable, UA){
  var Dialog = function(){
    this.hidden = true;
    this.mask = null;
    this.id = guid();
    this.__observableEvents = {};
    this.elt = this.create();
    this.contentWidth = null;
    this.contentHeight = null;
  };

  Dialog.prototype = _.extend(Dialog.prototype, Resize);
  Dialog.prototype = _.extend(Dialog.prototype, Observable);

  Dialog.prototype.create = function(){
    if (this.elt) return this.elt;
    var b, i, c, cl, m;
    m = document.createElement('div');
    DomHelper.addClass(m, 'id-dialog-mask');
    this.mask = m;
    DomHelper.on(window, 'resize', _.bind(function() { this.resizeMask(); }, this));

    b = document.createElement('div');
    DomHelper.addClass(b,'id-dialog-box');
    i = document.createElement('div');
    DomHelper.addClass(i,'id-dialog-inner');
    c = document.createElement('div');
    DomHelper.addClass(c,'id-dialog-content');
    c.appendChild(i);
    b.appendChild(c);
    document.body.appendChild(m);
    b.style.position = window.top === window ? 'fixed' : 'absolute';
    if(UA.mobile()){
      b.style.position = 'absolute';
    }
    b.style.top = '-10000px';
    b.style.display = 'block';
    b.style.left = (this.docWidth() / 2) + 'px';
    this.innerElt = i;
    this.subscribe('dialog.resize', function(w, h){
      var body = document.body, html = document.documentElement;
      var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );

      var maxHeight = height - 20;
      if (this.contentHeight) {
        maxHeight = this.contentHeight;
      }

      var overflow = h > maxHeight;
      b.style.width = w + 'px';
      if (overflow) {
        b.style.height = maxHeight + 'px';
        b.style.overflowY = 'scroll';
      } else {
        b.style.height = h + 'px';
        b.style.overflowY = 'visible';
      }

      this.resizeMask();
    });
    return b;
  };

  Dialog.prototype.destroy = function(){
    this.hide();
    document.body.removeChild(this.mask);
    var _destroy = function(){
      this.__observableEvents = {};
      this.elt.parentNode.removeChild(this.elt);
    };
    // Let it inform all subscribers
    window.setTimeout(_.bind(_destroy, this), 5000);
    return true;
  };

  Dialog.prototype.findContent = function(){
    return this.innerElt;
  };

  Dialog.prototype.visible = function(){
    return this.hidden;
  };

  Dialog.prototype.replaceContent = function(content){
    if(!content) return;
    if (_.isString(content)) {
      this.findContent().innerHTML = content;
    } else {
      this.findContent().innerHTML = "";
      this.findContent().appendChild(content);
    }
  };


  Dialog.prototype.setWidth = function(w){
    if (this.innerElt)
      this.innerElt.style.width = w + 'px';
  };

  Dialog.prototype.setHeight = function(h){
    if (this.innerElt)
      this.innerElt.style.height = h + 'px';
  };

  Dialog.prototype.setTop = function(t){
    if (this.elt)
      this.elt.style.top = t + 'px';
  };

  Dialog.prototype.setLeft = function(l){
    if (this.elt)
      this.elt.style.left = l + 'px';
  };

  Dialog.prototype.width = function(){
    return this.innerElt.offsetWidth;
  };

  Dialog.prototype.height = function(){
    return this.innerElt.offsetHeight;
  };

  Dialog.prototype.top = function(){
    return this.elt.offsetTop;
  };

  Dialog.prototype.left = function(){
    return this.elt.offsetLeft;
  };

  Dialog.prototype.call = function(message){
    if (this.called) { return; }
    this.called = true;
    return this.successFn(message);
  };

  Dialog.prototype.error = function(code, data){
    return this.errorFn(code, data);
  };


  // need this for position big dialogs after resize
  Dialog.prototype.scrollBarWidth = function(){
    return 30;
  };

  return Dialog;
});

